import { Injectable } from '@angular/core';
import { AES } from 'crypto-js';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class PrivacyService {

  public GetS(type:string,val:string):string {
    return AES.encrypt(val,type).toString();
  }
  public SGet(type:string,val:string):string {
    return AES.decrypt(val,type).toString(CryptoJS.enc.Utf8);
  }

  constructor() { }
}
